/* eslint-disable no-unused-vars */
import { app as vm } from '@/main';
import { getAuth, updatePassword, signOut } from 'firebase/auth';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { db, app } from '@/firebase/init.js';

import { collection, query, where, getDocs, doc, getDoc, updateDoc, onSnapshot } from 'firebase/firestore';

const messaging = getMessaging(app);

const adminModule = {
  namespaced: true,
  state: {
    user: {},
    uid: null,
    isLoading: true,
    // Unsubscribe handle for the live watch on this admin's own document.
    permissionsWatcher: null,
    vapidKey: 'BOvBT_Rh-syPECSg2_BlMY3-COrZhKcZ4u_1mKFd_vGkLDKCvakMB_XU0lFiJdeejLiS2QTXexTXStPNiTauL68',
  },
  getters: {
    getUser: (state) => state.user,
    getUid: (state) => state.uid,
    isLoading: (state) => state.isLoading,
  },
  mutations: {
    setUser: (state, payload) => {
      state.user = payload;
    },
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },
    setUid: (state, payload) => {
      state.uid = payload;
    },
    setPermissionsWatcher: (state, payload) => {
      state.permissionsWatcher = payload;
    },
  },
  actions: {
    // get Admin by uid
    async getAdminByUid({ commit, dispatch, state }) {
      commit('setLoading', true);
      const user = getAuth().currentUser;

      // Read by DOCUMENT ID — the same address the router guard uses. Querying
      // on the `uid` field instead split the two sources of truth for any
      // document whose id and `uid` field disagree.
      const adminDocument = await getDoc(doc(db, 'Admins', user.uid));
      if (adminDocument.exists()) {
        commit('setUser', { ...adminDocument.data(), uid: adminDocument.id });
      } else {
        // Fall back to the legacy field query for documents keyed differently.
        const q = query(collection(db, 'Admins'), where('uid', '==', user.uid));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((legacyDoc) => {
          commit('setUser', { ...legacyDoc.data(), uid: legacyDoc.id });
        });
      }

      dispatch('watchOwnPermissions');
      dispatch('handleAdminNotification');

      this.dispatch('notificationModule/getAllNotifications', user.uid);

      commit('setLoading', false);
    },

    // Keeps the signed-in admin's permissions live. Without this, an already
    // open session kept its old sidebar until the next navigation.
    watchOwnPermissions({ commit, state }) {
      if (state.permissionsWatcher) return;
      const user = getAuth().currentUser;
      if (!user) return;

      const unsubscribe = onSnapshot(
          doc(db, 'Admins', user.uid),
          (snapshot) => {
            if (!snapshot.exists()) return;
            commit('setUser', { ...snapshot.data(), uid: snapshot.id });
          },
          (error) => {
            console.error('Could not watch admin permissions', error);
          },
      );
      commit('setPermissionsWatcher', unsubscribe);
    },

    stopWatchingOwnPermissions({ commit, state }) {
      if (typeof state.permissionsWatcher === 'function') {
        state.permissionsWatcher();
      }
      commit('setPermissionsWatcher', null);
    },
    // Edit User
    async updateUser({ commit, state }, payload) {
      // const q = query(
      //   collection(db, "Admins"),
      //   where("uid", "==", getAuth().currentUser.uid)
      // );

      // const querySnapshot = await getDocs(q);
      // querySnapshot.forEach((admin) => {
      const documentReference = doc(db, 'Admins', getAuth().currentUser.uid);
      // Strip `permissions`: this is a profile edit. Writing the whole cached
      // user object back here silently restored permissions an admin had just
      // revoked.
      const { permissions, ...safePayload } = payload;
      await updateDoc(documentReference, safePayload);
      const auth = getAuth();
      const user = auth.currentUser;
      // if (payload.password) {
      //   updatePassword(user, payload.password)
      //       .then(() => {
      //         console.log('Password Changed');
      //       })
      //       .catch((error) => {
      //         console.log(error);
      //       });
      // }
      // });

      commit('setUser', { ...state.user, ...safePayload });
    },

    async handleAdminNotification({ commit, dispatch, state }) {
      // generate device token
      // const auth = getAuth();
      getToken(messaging, { vapidKey: state.vapidKey })
          .then((currentToken) => {
            if (currentToken) {
              // Send the token to your server and update the UI if necessary
              commit('setUser', { ...state.user, FCT: currentToken });
              const documentReference = doc(db, 'Admins', getAuth().currentUser.uid);
              // Write ONLY the token. This used to push the entire cached user
              // object — permissions included — on every AdminView mount, which
              // resurrected permissions that had just been revoked.
              updateDoc(documentReference, { FCT: currentToken }).catch((error) => {
                console.error('Could not store the device token', error);
              });
              // ...
            } else {
              // signOut(auth).then(() => {
              //   app.router.push('/');
              // });
            }
          })
          .catch((err) => {
            // signOut(auth).then(() => {
            //   vm.$router.push('/');
            // });
          });

      onMessage(messaging, (payload) => {
        const result = payload;
        console.log(result);
        const data = {
          ...result.notification,
          body: result.notification.body,
        };
        const notificationOption = {
          title: data.title,
          body: data.body,
        };
        if (Notification.permission === 'granted') {
          console.log(result);

          const audio = new Audio('/alert.wav');
          audio.play();
          new Notification(notificationOption.title, notificationOption);
        }
      });
    },
  },
};

export default adminModule;

